import { Award, HeartHandshake, Leaf } from 'lucide-react';
import HtmlContent from '../../components/common/HtmlContent.jsx';
import LoadingState from '../../components/common/LoadingState.jsx';
import PageHero from '../../components/common/PageHero.jsx';
import SectionHeader from '../../components/common/SectionHeader.jsx';
import Seo from '../../components/common/Seo.jsx';
import { useContent } from '../../hooks/useContent.js';

const pillars = [
  {
    icon: Leaf,
    title: 'Clean by Conviction',
    text: 'A life free from GMOs, glyphosate, hybridization, and microplastics — the values that shaped us.',
  },
  {
    icon: Award,
    title: 'Craft Since 2003',
    text: 'From the finest extra virgin olive oil to rare Syriaca honey, royal jelly, bee bread, and propolis.',
  },
  {
    icon: HeartHandshake,
    title: 'Rooted in Partnership',
    text: 'Working hand in hand with Mediterranean beekeepers and eco-friendly practices that protect the hive.',
  },
];

export default function AboutPage() {
  const { content, status } = useContent();
  if (status === 'loading') return <LoadingState label="Loading about page" />;

  return (
    <>
      <Seo
        title="About Us"
        description="Family owned since 2003 — La Bella Trading imports raw Mediterranean honey, rare bee products, extra virgin olive oil, and natural soaps to Canada."
        path="/about"
      />
      <PageHero
        eyebrow="Our Story"
        title={content.about.title}
        text="Purity, passion, and purpose — with every drop, spoonful, and jar."
        image="assets/uploads/about-banner.png"
      />
      <section className="container page-section narrow">
        <div className="detail-panel">
          <HtmlContent className="rich-text" html={content.about.content} />
        </div>
      </section>
      <section className="hive-band">
        <div className="container">
          <SectionHeader eyebrow="What guides us" title="The La Bella Pillars" />
          <div className="value-grid">
            {pillars.map((pillar) => (
              <div className="value-card" key={pillar.title}>
                <span className="hex-icon"><pillar.icon size={24} /></span>
                <h3>{pillar.title}</h3>
                <p>{pillar.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
